import React from "react";

export const zuhePublishedAt = (
  <span className="white">
    <i>Cuentos tricolores</i> (1967)
  </span>
);
